import gql from "graphql-tag";

export const SIGN_IN_WITH_EMAIL = gql`
  mutation signIn($data: UserAuthInput) {
    signIn(data: $data)
  }
`;
export const SIGN_UP_WITH_EMAIL = gql`
  mutation signUp($data: UserAuthInput) {
    signUp(data: $data)
  }
`;
export const RESET_PASSWORD = gql`
  mutation resetPassword($data: UserAuthInput) {
    resetPassword(data: $data)
  }
`;

export const PROVIDER_URL = gql`
  mutation getProviderUrl($provider: PROVIDER!) {
    getProviderUrl(provider: $provider)
  }
`;

export const SIGN_IN_WITH_PROVIDER = gql`
  mutation signInWithProvider($provider: PROVIDER!, $code: String!) {
    signInWithProvider(provider: $provider, code: $code) {
      access_token
      refresh_token
    }
  }
`;
export const REFRESH_TOKEN_PROVIDER = gql`
  mutation refreshTokenProvider($provider: PROVIDER!, $refreshToken: String!) {
    refreshTokenProvider(provider: $provider, refreshToken: $refreshToken) {
      access_token
      refresh_token
    }
  }
`;
